import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Input, Slider } from "antd";
import { FireTwoTone, FireOutlined } from "@ant-design/icons";
import { modalProjectRedItemTab } from "../../../types/initStore/initRetrospective";
import { IteamFormModal } from "./IteamFormModal";
import { RadarGraphics } from "../../Graphics/RadarGraphics";
import { ContainerModal } from "../../container/ContainerModal";
import { typeForDetailsProyect } from "../../../types/typeModalDetailsProject";

const style = { fontSize: "25px" };

let allForm = {};

const initForm = modalProjectRedItemTab.reduce((prev, current) => {
	return {
		...prev,
		[current.reason]: {
			comment: "",
			score: 0,
			titleRadar: current.titleRadar,
		},
	};
}, {});

export const FormProjectRed = ({ disabled = false, dataForm = [], editFormForProjectDetails, closeModalDetails }) => {

	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);

	const [graphData, setGraphData] = useState([]);
	const [numberIteam, setNumberIteam] = useState(0);
	const [iteaView, setIteaView] = useState(null);

	const setIteamSelect = useCallback((value = 0) => {
		setIteaView(modalProjectRedItemTab[value]);
		setNumberIteam(value);
	}, []);

	const updateGraph = () => {
		const key = Object.keys(form.getFieldsValue())[0];
		const values = Object.values(form.getFieldsValue())[0];
		const newRadarData = graphData.map((iteamRadar) => {
			if (iteamRadar.reason === key) {
				return {
					...iteamRadar,
					project: values.score === undefined ? 0 : values.score,
				};
			}
			return iteamRadar;
		});
		setGraphData(newRadarData);
	};

	const backButton = () => {
		setIteamSelect(numberIteam - 1);
		updateGraph();
	};

	const nextButton = () => {
		allForm = {
			...allForm,
			...form.getFieldsValue(),
		};
		updateGraph();
		if (numberIteam === modalProjectRedItemTab.length - 1) {
			finishForm(allForm);
			return;
		}
		setIteamSelect(numberIteam + 1);
	};

	const finishForm = async (values) => {
		if (disabled) {
			closeModalDetails();
			return;
		}
		setLoading(true);
		let formSelect = {};
		Object.entries(values).forEach(([key, value]) => {
			let score = value.score === undefined ? 0 : value.score;
			let commentValue = value.comment === undefined ? "-" : value.comment;
			formSelect = {
				...formSelect,
				[key]: {
					reason: key,
                    comment: commentValue === "" ? "-" : commentValue,
					score,
				},
			};
		});

        await editFormForProjectDetails(typeForDetailsProyect.projectRed, {
			information: Object.values(formSelect),
			isSave: !disabled,
		});
        setLoading(false);
	};

	const getFillDataForm = () => {
		const allModalRadar = [];
		let formCheck = {};

		Object.entries(initForm).forEach(([key, value]) => {
			formCheck = {
				...formCheck,
				[key]: {
					comment: "",
					score: 0,
				},
			};

			const findDataForm = dataForm.find((data) => data.reason === key);

			allModalRadar.push({
				name: value.titleRadar,
				project: !findDataForm ? 0 : findDataForm.score,
				reason: key,
			});

			if (!findDataForm) {
				return;
			}

			formCheck[key] = {
				comment: findDataForm.comment,
				score: findDataForm.score,
			};
		});
		return {
			allModalRadar,
			formCheck,
		};
	};

	useEffect(() => {
		const { allModalRadar, formCheck } = getFillDataForm();

		form.setFieldsValue(formCheck);

		setIteamSelect();
		setGraphData(allModalRadar);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-45 flex justify-center items-center">
				<ContainerModal
					title={"Razón de proyecto a rojos"}
					actionButton={() => {
						closeModalDetails();
					}}
					className={"w-[500px]"}
				>
					<Form form={form} onFinish={finishForm} className="w-full flex flex-col">
						{iteaView && (
							<IteamFormModal title={iteaView.title}>
								<div className="flex flex-col gap-4">
									<div className="w-full h-[300px]">
										<RadarGraphics data={graphData} />
									</div>
									<div className="flex flex-col gap-2">
										<p className="font-bold">Descripción</p>
										<p className="text-[#9A9A9A] text-[10px]">{iteaView.descriptionform}</p>
										<Form.Item name={[iteaView.reason, "comment"]}>
											<Input.TextArea
												placeholder="Comentario"
												autoSize={{
													minRows: 5,
													maxRows: 5,
												}}
												showCount={false}
												disabled={disabled}
											/>
										</Form.Item>
									</div>
									<div className="px-[70px]">
										<div className="flex justify-between gap-4">
											<FireOutlined style={{ ...style }} />
											<Form.Item name={[iteaView.reason, "score"]} className="w-full">
												<Slider min={0} max={5} trackStyle={{ backgroundColor: "red" }} disabled={disabled} />
											</Form.Item>
											<FireTwoTone twoToneColor="#FF6161" style={{ ...style }} />
										</div>
									</div>
								</div>
							</IteamFormModal>
						)}
						<div className=" flex justify-center items-center">
							<div className="flex gap-2">
								{modalProjectRedItemTab.map((_, index) => (
									<div key={`${index}-ball-blue`} className={`w-[20px] h-[20px] bg-[#CDCDCD] rounded-full p-1`}>
										<div className={` w-full h-full rounded-full ${numberIteam === index && "bg-primaryTwo"}`} />
									</div>
								))}
							</div>
						</div>
						<div className="w-full h-[40px] mt-4 overflow-hidden flex justify-end gap-4">
							{numberIteam > 0 && (
								<Button onClick={backButton} htmlType="button">
									Atras
								</Button>
							)}
							<Button onClick={nextButton} type="primary" className="bg-primaryTwo" loading={loading}>
								{numberIteam === modalProjectRedItemTab.length - 1 ? (disabled ? "Cerrar" : "Guardar") : "Siguiente"}
							</Button>
						</div>
					</Form>
				</ContainerModal>
			</div>
		</>
	);
};
